<template>
   <div id="search-tab-container" :style="isPackage ? 'padding-top:0!important; padding-bottom:1rem; margin-bottom:.5rem;' : ''">
      <!-- Group Flight Badge -->
      <div class="group-flight-badge" v-if="false">
         <RouterLink to="/group/flight/new" class="badge-link">
            <!-- <Icon name="message-chat-circle" /> -->
            <div class="badge-content">
               <span class="badge-title">{{ $t("searchTab_lblGroupFlightRequest") }}</span>
               <!-- <span class="badge-subtitle">Size özel teklifler alın</span> -->
            </div>
         </RouterLink>
      </div>

      <div class="search-tabs">
         <!-- FLIGHT SEARCH -->
         <router-link :disabled="!roles.includes(1)" :event="roles.includes(1) ? 'click' : ''" to="/flight" :class="{ disabled: !roles.includes(1) }">
            <div class="search-tab search-tab-flight" :class="activeTab == 1 ? 'active-tab' : ''">
               <i class="gts-icon icon-tab-flight-search d-none d-md-block"></i>
               <span class="search-tab-name">{{ $t("common_searchFlight") }}</span>
            </div>
         </router-link>

         <!-- HOTEL SEARCH -->
         <router-link :disabled="!roles.includes(2)" :event="roles.includes(2) ? 'click' : ''" to="/hotel" :class="{ disabled: !roles.includes(2) }">
            <div class="search-tab search-tab-hotel" :class="activeTab == 2 ? 'active-tab' : ''">
               <i class="gts-icon icon-tab-hotel-search d-none d-md-block"></i>
               <span class="search-tab-name">{{ $t("common_searchHotel") }}</span>
            </div>
         </router-link>
         <!-- Schimetterling-->
         <router-link :event="roles.includes(25) ? 'click' : ''" to="/packages" @click.native="handlerPackagesPopup" :class="{ disabled: !roles.includes(25) }">
            <div class="search-tab search-tab-schimetterling" :class="activeTab == 5 ? 'active-tab' : ''">
               <i class="gts-icon icon-tab-schimetterling-search d-none d-md-block"></i>
               <span class="search-tab-name">{{ $t("common_searchPackages") }}</span>
            </div>
         </router-link>

         <!-- TRANSFER SEARCH -->
         <router-link :disabled="!roles.includes(3)" :event="roles.includes(3) ? 'click' : ''" to="/transfer" :class="{ disabled: !roles.includes(3) }">
            <div class="search-tab search-tab-transfer" :class="activeTab == 3 ? 'active-tab' : ''">
               <i class="gts-icon icon-tab-transfer-search d-none d-md-block"></i>
               <span class="search-tab-name">{{ $t("common_searchTransfer") }}</span>
            </div>
         </router-link>

         <!-- RENT A CAR SEARCH -->
         <router-link :disabled="!roles.includes(22)" :event="roles.includes(22) ? 'click' : ''" to="/rentacar" :class="{ disabled: !roles.includes(22) }">
            <div class="search-tab search-tab-rentacar" :class="activeTab == 4 ? 'active-tab' : ''">
               <i class="gts-icon icon-tab-rentacar-search d-none d-md-block"></i>
               <span class="search-tab-name">{{ $t("common_searchRentACar") }}</span>
            </div>
         </router-link>
      </div>

      <div class="search-tab-content">
         <template v-if="activeTab == 1">
            <FlightSearchForm />
         </template>
         <template v-else-if="activeTab == 2">
            <!-- <HotelSearchForm @sticky-bar-status="handleScroll" /> -->
            <HotelSearchForm />
         </template>
         <template v-else-if="activeTab == 3">
            <TransferSearchForm />
         </template>
         <template v-else-if="activeTab == 4">
            <RentACarSearchForm />
         </template>
         <template v-else-if="activeTab == 5">
            <PackageIframe :iframeInformations="iframeInformations" />
         </template>
      </div>
   </div>
</template>

<script>
// import Popup from "@/gts-popup.js";
import FlightSearchForm from "@/components/structural/flight/search/FlightSearchForm.vue";
import HotelSearchForm from "@/components/structural/hotel/common/HotelSearchForm.vue";
import TransferSearchForm from "@/components/structural/transfer/search/TransferSearchForm.vue";
import RentACarSearchForm from "@/components/structural/rentacar/search/RentACarSearchForm.vue";
import PackageIframe from "@/components/unitary/form2/PackageIframe.vue";

export default {
   name: "SearchTab",
   props: {
      activeTab: Number,
      isPackage: Boolean,
      iframeInformations: Object,
   },
   components: {
      FlightSearchForm,
      HotelSearchForm,
      TransferSearchForm,
      RentACarSearchForm,
      PackageIframe,
   },
   data() {
      return {
         roles: [],
      };
   },

   mounted() {
      this.roles = JSON.parse(localStorage.getItem("auths"));
      if (this.isPackage) {
         const searchTabContainer = document.querySelector("#search-tab-container");
         if (searchTabContainer) {
            const positionFromTop = searchTabContainer.getBoundingClientRect().top + 60;
            const differenceInVH = 100 - (positionFromTop / window.innerHeight) * 100;
            differenceInVH;
            // searchTabContainer.style.height = `${differenceInVH}vh`;
         }
      }
   },
   methods: {
      handlerPackagesPopup() {
         // Popup.info(this.$i18n.t("Popup_lblPackagesTitle"), this.$i18n.t("Popup_lblPackagesContent"));
      },
   },
};
</script>

<style lang="scss" scoped>
#search-tab-container {
   position: relative;
   background: var(--container-bg);
   padding: 4rem 0.75rem;
   margin: 0rem;
   border-radius: 0.5rem;

   #iframe-wrapper {
      width: 100%;
      height: 100%;
      border: 1px solid;

      iframe {
         width: 100%;
         height: 100%;
      }
   }

   &.--stickyModeOn {
      position: sticky;
      top: 0;
      z-index: 10;
      @media (max-width: 991px) {
         top: 82px;
      }
   }
   &.sticky {
      padding: 0;
      border-radius: 58px;
      .search-tabs {
         display: none;
      }
   }

   @media (min-width: 576px) {
      margin: 1.5rem 0rem;
      padding: 3rem 2rem;
   }

   .search-tabs {
      display: flex;
      position: absolute;
      bottom: 100%;
      align-items: flex-end;

      a {
         &.disabled {
            opacity: 0.5;
            pointer-events: none;
         }
      }
      @media (max-width: 576px) {
         width: 100%;

         overflow-x: scroll;
      }
      .search-tab {
         display: flex;
         align-items: center;
         //background-color: var(--gray-50);
         background-color: var(--container-bg);
         margin: 0 0.35rem;
         padding: 0.25rem 0.85rem;

         border-radius: 0.5rem;
         border-bottom-left-radius: 0;
         border-bottom-right-radius: 0;
         border-bottom: 1px solid var(--gray-200);
         height: 50px !important;

         &:first-child {
            margin-left: 0;
         }

         i {
            &.icon-tab-transfer-search {
               width: 46px !important;
            }
         }

         span {
            margin-left: 0.5rem;
            color: var(--search-tabs-color);
            font-weight: 500;
            white-space: nowrap;
         }

         &.active-tab {
            padding: 0.25rem 0.85rem;
            padding-top: 0.75rem;

            &.search-tab-flight {
               background: var(--product-flight);
            }
            &.search-tab-hotel {
               background: var(--product-hotel);
            }
            &.search-tab-transfer {
               background: var(--product-transfer);
            }
            &.search-tab-rentacar {
               background: var(--product-rentacar);
            }
            &.search-tab-schimetterling {
               background: var(--product-package);
            }

            span.search-tab-name {
               color: #fff;
            }
            i.gts-icon {
               filter: brightness(10);
            }
         }

         &.search-tab-schimetterling {
            i.gts-icon {
               height: 60px !important;
               width: 70px !important;
            }
         }
      }
   }
   .search-tab-content {
      margin-top: 0rem;
      height: 100%;
      height: 100%;
      @media (min-width: 576px) {
      }
   }

   .group-flight-badge {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 0;

      @media (max-width: 991.98px) {
         display: none;
      }

      .badge-link {
         display: flex;
         align-items: center;
         justify-content: center;
         gap: 0.5rem;
         padding: 0.5rem 0.5rem;
         background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
         color: #ffffff;
         text-decoration: none;
         border-radius: 0.5rem;
         border-top-left-radius: 0;
         border-bottom-right-radius: 0;
         border-bottom-left-radius: 0.75rem;
         // box-shadow: 0 4px 16px rgba(255, 107, 53, 0.4);
         transition: all 0.3s ease;
         border: 2px solid rgba(255, 255, 255, 0.3);
         border-bottom: none;
         // background: #ff3e74;

         &:hover {
            background: linear-gradient(135deg, #f7931e 0%, #ff6b35 100%);
            transform: translateY(-4px);
            box-shadow: 0 6px 20px rgba(255, 107, 53, 0.6);
            color: #ffffff;
            border-color: rgba(255, 255, 255, 0.5);
         }

         ::v-deep svg {
            stroke: #ffffff !important;
         }

         .badge-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 0;

            .badge-title {
               font-size: 14px;
               font-weight: 700;
               white-space: nowrap;
            }

            .badge-subtitle {
               font-size: 11px;
               font-weight: 400;
               opacity: 0.9;
               white-space: nowrap;
            }
         }

         span {
            white-space: nowrap;
         }
      }
   }
}
</style>
